import type { QueryKey } from '@tanstack/react-query';
import type { GitHubAppInstallation } from '../../../../../shared/model-typings';
import { get } from '../../../../redux/api';
import type { PaginatedResponse } from '../../../../../shared/types/routes/pagination';
import { useQuery } from '../../../../ReactQuery';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

const queryKey: QueryKey = ['github-app', 'installations'];

const fetchInstallations = async (): Promise<QueryResponse<PaginatedResponse<GitHubAppInstallation>>> => {
  const response = await get<PaginatedResponse<GitHubAppInstallation>>('/api/services/github-app/installations');

  if (response.status !== 200) {
    return response;
  }

  const data = response.data as PaginatedResponse<GitHubAppInstallation>;
  data.results = data.results.map((i) => ({
    ...i,
    createdAt: new Date(i.createdAt),
    updatedAt: new Date(i.updatedAt),
  }));

  return {
    ...response,
    data,
  };
};

/**
 * Hook to fetch GitHub App Installations for an organization.
 */
export default function useGetGitHubAppInstallations() {
  return useQuery({
    queryKey,
    queryFn: fetchInstallations,
  });
}
